import { ToastrService } from 'ngx-toastr';
import { TrocarEmpresaService } from './../../services/trocar-empresa.service';
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { NgClass } from '@angular/common';
import { CamelCasePipe } from '../../pipes/camel-case.pipe';
import { CnpjPipe } from '../../pipes/cnpj.pipe';

@Component({
    selector: 'app-alert-trocar-empresa',
    templateUrl: './alert-trocar-empresa.component.html',
    styleUrls: ['./alert-trocar-empresa.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, CamelCasePipe, CnpjPipe]
})
export class AlertTrocarEmpresaComponent {

  nomeEmpresaLogada: string = localStorage.nomeEmpresa;
  cnpjEmpresaLogada: string = localStorage.cnpj;
  @Input() nomeEmpresaDestino: string;
  @Input() cnpjEmpresaDestino: string;
  @Input() companyIdDestino: number;
  @Input() alertAlterarEmpresa: boolean = false;

  @Output() alertAlterarEmpresaFechou = new EventEmitter();
  @Output() desativarBotao = new EventEmitter();

  constructor(private readonly trocarEmpresaService: TrocarEmpresaService,
    private readonly toastr: ToastrService,
    private readonly router: Router
  ) { }

  onSubmit() {
    this.trocarEmpresaService.subject.next({ cnpj: this.cnpjEmpresaDestino, idEmpresa: this.companyIdDestino, nomeEmpresa: this.nomeEmpresaDestino });
    this.desativarBotao.emit('Desativa');
    this.cancelarAlterarEmpresa();
    this.toastr.success('Troca realizada com sucesso', '', {
      timeOut: 2000,
    });
  }

  cancelarAlterarEmpresa() {
    this.alertAlterarEmpresa = false;
    this.alertAlterarEmpresaFechou.emit(this.alertAlterarEmpresa);
  }

}
